import { createFileRoute } from '@tanstack/react-router';
import { PeoplePresencePage } from '@/features/workforce/PeoplePresencePage';
import { PRESENCE_TABS, type PresenceTab } from '@/features/workforce/presenceTabs';
import type { TeamView } from '@/features/attendance/TeamMonthPage';

/**
 * `/hr/presence` — «Presenze del personale»: oggi, per sede, atteso del team (03-11-2026).
 *
 * `?tab=` sceglie la scheda; `?teamView=giorno|settimana` apre l'atteso su quella vista, come
 * faceva `/attendance/team-month` (ci arriva «Presenze» per la giornata di un collega).
 */
export const Route = createFileRoute('/_app/hr/presence')({
  validateSearch: (s: Record<string, unknown>): { tab?: PresenceTab; teamView?: TeamView } => ({
    tab: PRESENCE_TABS.includes(s.tab as PresenceTab) ? (s.tab as PresenceTab) : undefined,
    teamView: s.teamView === 'giorno' || s.teamView === 'settimana' ? s.teamView : undefined,
  }),
  component: PresenceRoute,
});

function PresenceRoute() {
  const { tab, teamView } = Route.useSearch();
  return <PeoplePresencePage tab={tab} teamView={teamView} />;
}
